import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";

export default function DemoPreviewSection() {
  return (
    <section
      data-testid="demo-preview-section"
      className="py-24 px-6"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span
            className="text-xs uppercase tracking-wider mb-4 block"
            style={{
              color: "#F59E0B",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "11px",
            }}
          >
            Interactive Demo
          </span>
          <h2
            className="text-3xl sm:text-4xl font-semibold tracking-tight text-white mb-4"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            See Runzr in action
          </h2>
          <p className="text-base mb-10 max-w-lg mx-auto" style={{ color: "#A1A1AA" }}>
            Watch an agent session run on desktop, trigger a notification, and
            get handled from mobile — in real time.
          </p>
        </motion.div>

        {/* Demo preview card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Link
            to="/demo"
            data-testid="demo-preview-link"
            className="block no-underline group"
          >
            <div
              className="relative rounded-xl overflow-hidden p-8 sm:p-12 transition-all duration-300"
              style={{
                background: "rgba(255,255,255,0.02)",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)";
                e.currentTarget.style.background = "rgba(255,255,255,0.04)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)";
                e.currentTarget.style.background = "rgba(255,255,255,0.02)";
              }}
            >
              {/* Simulated preview */}
              <div className="flex items-center justify-center gap-6 mb-8">
                {/* Mini terminal */}
                <div
                  className="w-48 h-28 rounded-lg"
                  style={{
                    background: "#0D0D0D",
                    border: "1px solid rgba(255,255,255,0.08)",
                  }}
                >
                  <div
                    className="flex items-center gap-1.5 px-3 py-2"
                    style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}
                  >
                    <div className="w-2 h-2 rounded-full" style={{ background: "#FF5F56" }} />
                    <div className="w-2 h-2 rounded-full" style={{ background: "#FFBD2E" }} />
                    <div className="w-2 h-2 rounded-full" style={{ background: "#27C93F" }} />
                  </div>
                  <div className="px-3 py-2 space-y-1">
                    <div className="h-1.5 w-24 rounded" style={{ background: "rgba(255,255,255,0.1)" }} />
                    <div className="h-1.5 w-16 rounded" style={{ background: "rgba(16,185,129,0.3)" }} />
                    <div className="h-1.5 w-20 rounded" style={{ background: "rgba(245,158,11,0.3)" }} />
                    <div className="h-1.5 w-12 rounded" style={{ background: "rgba(255,255,255,0.05)" }} />
                  </div>
                </div>

                {/* Arrow */}
                <div className="text-sm" style={{ color: "#71717A" }}>→</div>

                {/* Mini phone */}
                <div
                  className="w-20 h-36 rounded-2xl"
                  style={{
                    background: "#000",
                    border: "2px solid rgba(255,255,255,0.12)",
                  }}
                >
                  <div className="px-2 pt-6 space-y-1.5">
                    <div className="h-1 w-10 rounded" style={{ background: "rgba(255,255,255,0.1)" }} />
                    <div
                      className="h-6 rounded-md"
                      style={{
                        background: "rgba(255,255,255,0.04)",
                        border: "1px solid rgba(255,255,255,0.08)",
                      }}
                    />
                    <div className="flex gap-1 mt-1">
                      <div className="flex-1 h-3 rounded" style={{ background: "rgba(255,255,255,0.08)" }} />
                      <div className="flex-1 h-3 rounded" style={{ background: "rgba(255,255,255,0.04)" }} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center gap-3">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center"
                  style={{
                    background: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.15)",
                  }}
                >
                  <Play className="w-4 h-4 text-white ml-0.5" />
                </div>
                <span className="text-sm font-medium text-white">
                  Open interactive demo
                </span>
              </div>
            </div>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
